import axios from 'axios';
import { Input } from 'components/common/input';
import { apiConfig, COOKIE_NAME } from 'config';
import { useGetBookingData } from 'hooks';
import { getCookie } from 'lib';
import { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import './BookingWidgetForm.css';
import { isArray, isEmpty } from 'lodash';
import { BarsLoadingIndicator } from 'components/common/barsLoadingIndicator';
import { Checkbox } from 'components/common/checkbox';
import PropTypes from 'prop-types';

import {
    FaChartBar,
    FaCheck,
    FaEnvelope,
    FaLock,
    FaRegCalendarAlt,
    FaUserAlt,
} from 'react-icons/fa';
import {
    setSelectedRoomForm,
    setSelectedRateID,
    setSelectedFormRoom,
} from 'features/roomBookingFormSlice';
import Carousel from 'nuka-carousel';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { Dropdown } from 'components/common/dropdown';
import { FinalStepBookingForm } from 'components/finalStepBookingForm';
import { setSelectedCancellationAndPaymentPolicyData } from 'features/userSlice';
import { openModal } from 'features/modalSlice';

function BookingWidgetForm({ extraClass }) {
    const dispatch = useDispatch();
    const { userBookingData } = useGetBookingData();
    const colors = useSelector(
        (state) => state.miniBookingWidget?.data?.colors
    );
    const pluginCountries = useSelector(
        (state) => state.miniBookingWidget?.data?.pluginCountries
    );
    const currencySymbol = useSelector(
        (state) => state.miniBookingWidget?.data?.ourPrice?.currencySymbol
    );

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    const propertyID = useSelector(
        (state) => state.miniBookingWidget?.data?.propertyID
    );

    const div1Ref = useRef();
    const div2Ref = useRef();
    const div3Ref = useRef();

    const rateID = useSelector((state) => state.roomForm?.selectedRoomIndex);
    const roomForm = useSelector((state) => state.roomForm) || {};

    const room = roomForm?.room;
    const rate = roomForm?.room?.rates[0];

    const [firstName, setFirstName] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [nationality, setNationality] = useState(
        pluginCountries[0]?.countryName
    );
    const [specialRequests, setSpecialRequests] = useState('');
    const [checked, setChecked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [currentStep, setCurrentStep] = useState(1);
    const [postalCode, setPostalCode] = useState('');
    const [bookingID, setBookingID] = useState(null);
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [stateRegion, setStateRegion] = useState('');
    const [card, setCard] = useState({
        cardno: '',
        cardtype: '',
        expirydt: '',
        cvv: '',
        cardname: '',
    });

    const handleInfoIconClick = useCallback((data) => {
        dispatch(setSelectedCancellationAndPaymentPolicyData({ ...data }));
        dispatch(
            openModal({
                modalId: 'CancellationAndPaymentPolicyModal',
            })
        );
    }, []);

    const handleScroll = (ref) => {
        ref.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
        });
    };
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const validateInputs = () => {
        const errors = {};
        let scrolled = false;
        if (!firstName) {
            errors.firstName = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div1Ref);
            }
        }

        if (!lastname) {
            errors.lastname = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div1Ref);
            }
        }

        if (!email || !emailRegex.test(email)) {
            errors.email = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div1Ref);
            }
        }

        if (!phone) {
            errors.phone = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div1Ref);
            }
        }

        // if (!city) {
        //     errors.city = Lang?.requiredField;
        //     if (!scrolled) {
        //         scrolled = !scrolled;
        //         handleScroll(div1Ref);
        //     }
        // }

        // if (!nationality) {
        //     errors.nationality = Lang?.requiredField;
        //     if (!scrolled) {
        //         scrolled = !scrolled;
        //         handleScroll(div1Ref);
        //     }
        // }

        if (!card?.cardno) {
            errors.cardno = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div2Ref);
            }
        }

        if (!card?.expirydt) {
            errors.expirydt = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div2Ref);
            }
        }

        if (!card?.cvv) {
            errors.cvv = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div2Ref);
            }
        }

        if (!card?.cardname) {
            errors.cardname = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div2Ref);
            }
        }

        if (!checked) {
            errors.checked = Lang?.requiredField;
            if (!scrolled) {
                scrolled = !scrolled;
                handleScroll(div3Ref);
            }
        }

        return errors;
    };

    const dropdownOptions = isArray(pluginCountries)
        ? pluginCountries.map((item) => {
              let countryName = item?.countryName;
              if (item?.countryName === 'EN') {
                  countryName = 'US';
              }

              return {
                  dropdownText: item?.countryLocalFullName,
                  dropdownImg: item?.countryImg,
                  dropdownSelected: item?.dropdownSelected,
                  dropdownExtraData: {
                      countryCode: countryName,
                  },
                  dropdownValue: countryName,
              };
          })
        : [];

    const onChange = (e) => {
        const cartypeNew = cardnumber(e.target.value);
        setCard({
            ...card,
            cardno: e.target.value,
            cardtype: cartypeNew,
        });
    };
    const cardnumber = (inputtxt) => {
        const matches = inputtxt.match(/(\d+)/);
        let cardno = '';
        if (matches) {
            cardno = inputtxt.split(' - ').join('');
        }
        let cardtype1 = card.cardtype;

        const visa = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
        const mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
        const amexpRegEx = /^(?:3[47][0-9]{13})$/;
        const discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
        if (visa.test(cardno) === true) {
            // eg:4651970022334445
            cardtype1 = 'Visa';
        } else if (mastercardRegEx.test(cardno) === true) {
            cardtype1 = 'MasterCard';
        } else if (amexpRegEx.test(cardno) === true) {
            cardtype1 = 'AmericanExpress';
        } else if (discovRegEx.test(cardno) === true) {
            cardtype1 = 'Discover';
        }
        return cardtype1;
    };

    const ccFormat = (value) => {
        const v = value.replace(/[^0-9]/gi, '').substr(0, 16);

        const parts = [];
        for (let i = 0; i < v.length; i += 4) {
            parts.push(v.substr(i, 4));
        }
        return parts.length > 1 ? parts.join(' - ') : value;
    };
    const expriyFormat = (value) => {
        const expdate = value;
        const expDateFormatter =
            expdate.replace(/\//g, '').substring(0, 2) +
            (expdate.length > 2 ? '/' : '') +
            expdate.replace(/\//g, '').substring(2, 4);

        return expDateFormatter;
    };
    const onChangeExp = (e) => {
        setCard({
            ...card,
            expirydt: e.target.value,
        });
    };
    const onChangeCVV = (e) => {
        setCard({
            ...card,
            cvv: e.target.value,
        });
    };
    const onChangeCardName = (e) => {
        setCard({
            ...card,
            cardname: e.target.value,
        });
    };

    const closeRoomForm = () => {
        dispatch(setSelectedRoomForm({ selectedRoomFormIndex: null }));
        dispatch(setSelectedRateID({ selectedRateID: null }));
        dispatch(setSelectedFormRoom({ room: {} }));
    };

    // const handleModalClose = useCallback(() => {
    //     closeRoomForm();
    // });

    const tmpUserBookingData = { ...userBookingData };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const errors = validateInputs();
        setErrors(errors);

        if (!isEmpty(errors)) {
            return;
        }

        const cookie = getCookie(COOKIE_NAME);
        let tmpNationality = nationality;
        if (nationality === 'EN') {
            tmpNationality = 'US';
        }
        try {
            setIsLoading(true);
            const response = await axios.post(apiConfig?.roomForm, {
                ...tmpUserBookingData,
                lang: userBookingData?.localeLanguage,
                firstName,
                lastname,
                email,
                phone,
                nationality: tmpNationality,
                specialRequests,
                card: card.cardno,
                cvv: card.cvv,
                expiration: card.expirydt,
                cardName: card.cardname,
                cardtype: card.cardtype,
                cookie,
                propertyID,
                rateID,
                rateid: rate.rateID,
                timeofday: Date.now(),
                address,
                city,
                stateRegion,
                postalCode,
                price: rate?.pricing?.price,
                roomTypeID: rate?.roomTypeID,
                rateDetailID: rate?.rateDetailID,
                discountID: rate?.discountID,
            });

            if (response?.data.split(',')[0].toLowerCase() === 'booked') {
                toast.success(Lang?.successMessage, {
                    autoClose: true,
                    theme: 'colored',
                });
                setBookingID(response?.data.split(',')[1]);
                setCurrentStep(2);
            } else {
                toast.error(Lang?.somethingWentWrong, {
                    autoClose: true,
                    theme: 'colored',
                    PlacementType: 'top-left',
                });
            }
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
        }

        // handleModalClose();
        setIsLoading(false);
    };
    const d1 = Date.parse(tmpUserBookingData.checkin);
    const d2 = Date.parse(tmpUserBookingData.checkout);

    const nights = Math.round((d2 - d1) / (1000 * 60 * 60 * 24));

    let step1Class = '';
    let step2Class = '';
    let cursorStyle = {};
    if (currentStep === 1) {
        step1Class = ' ab-active';
        cursorStyle = { cursor: 'pointer' };
    } else {
        step2Class = ' ab-active';
    }

    if (isEmpty(room)) {
        return null;
    }

    let redBorderClass = '';
    if (errors?.nationality) {
        redBorderClass = 'ab-reb-border';
    }
    return (
        <div className={`ab-room-info-page ${extraClass}`}>
            <div className="ab-column">
                <div className="ab-body-inner-header">
                    <div className="ab-steps-line">
                        <div
                            className="ab-line-step"
                            onClick={currentStep === 1 && closeRoomForm}
                            style={{ ...cursorStyle }}
                        >
                            <div className="ab-step-dot ab-step-back">1</div>
                            <div
                                className="ab-step-text"
                                style={{
                                    textTransform: 'capitalize',
                                }}
                            >
                                {Lang.backTo} {Lang.roomSelection} 1/1
                            </div>
                        </div>
                        <div className={`ab-line-step ${step1Class}`}>
                            <div className="ab-step-dot">2</div>
                            <div className="ab-step-text">
                                {Lang.billingInformation}
                            </div>
                        </div>
                        <div className={`ab-line-step ${step2Class}`}>
                            <div className="ab-step-dot">
                                <FaCheck />
                            </div>
                            <div className="ab-step-text">{Lang.confirm}</div>
                        </div>
                    </div>
                </div>
                <div className="ab-body-innerMain">
                    {currentStep === 1 ? (
                        <form
                            onSubmit={handleSubmit}
                            noValidate
                            style={{ display: 'flex', width: '100%' }}
                        >
                            <div className="ab-body-sidebar ab-book-form-side-overf">
                                <div className="ab-body-sidebar-inner">
                                    <div className="ab-body-sidebar-section ab-whitebox ab-box-shadow">
                                        <div className="ab-whitebox-big-title ab-plr-10">
                                            {Lang.yourBookingDetails}
                                        </div>
                                        <div className="ab-room-image-container ab-image-carousel ab-plr-10">
                                            {Array.isArray(room?.photos) &&
                                                room.photos.length > 0 && (
                                                    <div className="ab-booking-imformation ab-roominfo-images-container">
                                                        <Carousel
                                                            defaultControlsConfig={{
                                                                // TODO: THIS HERE THROWS A WARNING
                                                                prevButtonText:
                                                                    (
                                                                        <IoIosArrowBack
                                                                            size={
                                                                                20
                                                                            }
                                                                        />
                                                                    ),
                                                                nextButtonText:
                                                                    (
                                                                        <IoIosArrowForward
                                                                            size={
                                                                                20
                                                                            }
                                                                        />
                                                                    ),
                                                                prevButtonClassName:
                                                                    'ab-image-carousel-prev-btn',
                                                                nextButtonClassName:
                                                                    'ab-image-carousel-next-btn',
                                                            }}
                                                            cellSpacing={10}
                                                        >
                                                            {room.photos.map(
                                                                (
                                                                    photo,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <img
                                                                            src={
                                                                                photo.medium
                                                                            }
                                                                            key={
                                                                                index
                                                                            }
                                                                            style={{
                                                                                width: 'auto',
                                                                                height: '150px',
                                                                                margin: '0 auto',
                                                                            }}
                                                                        />
                                                                    );
                                                                }
                                                            )}
                                                        </Carousel>
                                                    </div>
                                                )}
                                        </div>

                                        <div className="ab-plr-10">
                                            <div className="ab-whitebox-secondary-title">
                                                {room?.name}
                                            </div>
                                            <div className="ab-room-info-line">
                                                <div className="info-line-icon">
                                                    <FaRegCalendarAlt color="#343434" />
                                                </div>
                                                <div className="info-line-text">
                                                    {tmpUserBookingData.checkin
                                                        .split('-')
                                                        .reverse()
                                                        .join('-')}{' '}
                                                    -{' '}
                                                    {tmpUserBookingData.checkout
                                                        .split('-')
                                                        .reverse()
                                                        .join('-')}
                                                </div>
                                            </div>
                                            <div className="ab-room-info-line">
                                                <div className="info-line-icon">
                                                    <FaUserAlt color="#343434" />
                                                </div>
                                                <div className="info-line-text">
                                                    {Lang.Adults}:{' '}
                                                    {tmpUserBookingData.adults}
                                                </div>
                                            </div>
                                            <div className="ab-room-info-line">
                                                <div className="info-line-icon">
                                                    <FaChartBar color="#343434" />
                                                </div>
                                                <div className="info-line-text">
                                                    Rate: {rate?.rate}
                                                    {' - '}
                                                    {
                                                        rate?.cancelationPolicyType
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ab-price-inner-top ab-bg-paleblue">
                                            <span>{Lang.total}</span>{' '}
                                            <span>
                                                {rate?.pricing?.price}{' '}
                                                {currencySymbol}
                                            </span>
                                        </div>
                                        <div className="ab-price-line-p ab-plr-10 ab-pb-10 ab-pt-10">
                                            <span className="price-line-text">
                                                {Lang.roomPrice} (
                                                {tmpUserBookingData.rooms}{' '}
                                                {Lang.rooms} × {nights}{' '}
                                                {Lang.nights})
                                            </span>
                                            <span className="pricespan">
                                                {rate?.pricing?.price}{' '}
                                                {currencySymbol}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="ab-body-sidebar-section ab-whitebox ab-info-box ab-mb-20 ab-p-10 ab-box-shadow">
                                        <div className="ab-bordered-title">
                                            {Lang.howMuchWillItCostToCancel}?
                                        </div>
                                        <div
                                            className="ab-price-line-p"
                                            style={{ flexDirection: 'column' }}
                                        >
                                            {rate?.rateDescription && (
                                                <span
                                                    style={{
                                                        marginBottom: '10px',
                                                    }}
                                                    className="price-line-text"
                                                    dangerouslySetInnerHTML={{
                                                        __html: rate?.rateDescription.replace(
                                                            /\./g,
                                                            '.<br/>'
                                                        ),
                                                    }}
                                                ></span>
                                            )}

                                            {rate?.paymentPolicy && (
                                                <span
                                                    style={{
                                                        marginBottom: '10px',
                                                    }}
                                                    className="price-line-text"
                                                    dangerouslySetInnerHTML={{
                                                        __html: rate?.paymentPolicy.replace(
                                                            /\./g,
                                                            '.<br/>'
                                                        ),
                                                    }}
                                                ></span>
                                            )}
                                            {rate?.cancelationPolicy && (
                                                <span
                                                    className="price-line-text"
                                                    dangerouslySetInnerHTML={{
                                                        __html: rate?.cancelationPolicy.replace(
                                                            /\./g,
                                                            '.<br/>'
                                                        ),
                                                    }}
                                                ></span>
                                            )}
                                        </div>
                                    </div>
                                    {/* {rate?.paymentPolicy && (
                                        <div className="ab-body-sidebar-section ab-whitebox ab-info-box ab-mb-20 ab-p-10 ab-box-shadow">
                                            <div className="ab-bordered-title">
                                                {Lang.paymentPolicy}
                                            </div>
                                            <div className="ab-price-line-p">
                                                <span
                                                    className="price-line-text"
                                                    dangerouslySetInnerHTML={{
                                                        __html: rate?.paymentPolicy.replace(
                                                            /\./g,
                                                            '.<br/>'
                                                        ),
                                                    }}
                                                ></span>
                                            </div>
                                        </div>
                                    )} */}
                                </div>
                            </div>
                            <div className="ab-book-form-right-wrapper">
                                <div className="ab-body-main ab-book-form-overf">
                                    <div
                                        className="ab-whitebox ab-p-10 ab-box-shadow"
                                        style={{ minHeight: '280px' }}
                                    >
                                        <div className="ab-whitebox-big-title ab-bf-black">
                                            {Lang.contactAndPayment}
                                        </div>

                                        <div
                                            ref={div1Ref}
                                            className="ab-booking-form"
                                        >
                                            <div className="ab-input-field-cnt ab-mb-10">
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.firstName}
                                                        <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span>
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setFirstName(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        isRequired
                                                        isInvalid={Boolean(
                                                            errors?.firstName
                                                        )}
                                                        errorMsg={
                                                            errors.firstName
                                                        }
                                                        isRequiredBorder={true}
                                                        id="form-FirstName"
                                                    />
                                                </div>
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.lastName}
                                                        <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span>
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setLastname(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        isRequired
                                                        isInvalid={Boolean(
                                                            errors?.lastname
                                                        )}
                                                        errorMsg={
                                                            errors.lastname
                                                        }
                                                        isRequiredBorder={true}
                                                        id="form-LastName"
                                                    />
                                                </div>
                                            </div>

                                            <div className="ab-input-field-cnt ab-mb-10">
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.email}
                                                        <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span>
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setEmail(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        isRequired
                                                        isInvalid={Boolean(
                                                            errors?.email
                                                        )}
                                                        errorMsg={errors.email}
                                                        isRequiredBorder={true}
                                                        id="form-Email"
                                                    />
                                                </div>
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.phone}
                                                        <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span>
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setPhone(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        isRequired
                                                        isInvalid={Boolean(
                                                            errors?.phone
                                                        )}
                                                        errorMsg={errors.phone}
                                                        isRequiredBorder={true}
                                                        id="form-Phone"
                                                    />
                                                </div>
                                            </div>

                                            <div className="ab-input-field-cnt ab-mb-10">
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.city}
                                                        {/* <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span> */}
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setCity(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                        // isRequired
                                                        // isInvalid={Boolean(
                                                        //     errors?.city
                                                        // )}
                                                        // errorMsg={errors?.city}
                                                        // isRequiredBorder={true}
                                                        id="form-City"
                                                    />
                                                </div>
                                                <div
                                                    className=" ab-input-cnt"
                                                    style={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                    }}
                                                >
                                                    <label className="ab-input-label">
                                                        {Lang.nationality}
                                                        {/* <span
                                                            className="ab-input-required-indicator"
                                                            role="presentation"
                                                            aria-hidden="true"
                                                        >
                                                            *
                                                        </span> */}
                                                    </label>

                                                    <div className="ab-input ab-input-cnt">
                                                        <Dropdown
                                                            onChange={(
                                                                option
                                                            ) => {
                                                                setNationality(
                                                                    option
                                                                        ?.dropdownExtraData
                                                                        ?.countryCode
                                                                );
                                                            }}
                                                            searchable
                                                            options={
                                                                dropdownOptions ||
                                                                []
                                                            }
                                                            showTextWhenSelected={
                                                                true
                                                            }
                                                            extraClass={`ab-nationality-dropdown ${redBorderClass}`}
                                                            id="form-Nationality"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="ab-input-field-cnt ab-mb-10">
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.stateRegion}
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setStateRegion(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                    />
                                                </div>
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.postalCode}
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setPostalCode(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                    />
                                                </div>
                                            </div>

                                            <div
                                                className="ab-input-field-cnt ab-mb-10"
                                                style={{ display: 'none' }}
                                            >
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.address}
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setAddress(
                                                                e.target.value
                                                            )
                                                        }
                                                        className="ab-input"
                                                    />
                                                </div>
                                                <div className=" ab-input-cnt"></div>
                                            </div>

                                            <div className="ab-input-field-cnt ab-mb-10">
                                                <div className=" ab-input-cnt">
                                                    <label className="ab-input-label">
                                                        {Lang.specialRequests}
                                                    </label>
                                                    <Input
                                                        onChange={(e) =>
                                                            setSpecialRequests(
                                                                e.target.value
                                                            )
                                                        }
                                                        type="textarea"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="ab-whitebox ab-box-shadow"
                                        style={{
                                            minHeight: '330px',
                                            marginBottom: '2px',
                                        }}
                                    >
                                        <div className="ab-whitebox-header">
                                            <div className="first-part">
                                                <FaLock /> {Lang.securePayment}
                                            </div>
                                            <div className="second-part">
                                                {
                                                    Lang.allCardDetailsAreEncrypted
                                                }
                                                .
                                            </div>
                                        </div>
                                        <div className="ab-whitebox-body ab-p-10">
                                            <div className="ab-whitebox-secondary-title ab-flex-between ab-mb-20 ab-bg-lightblue ab-pt-8 ab-pb-4 ab-pl-10 ab-pr-10">
                                                <span>
                                                    {Lang.creditCardUpper}
                                                </span>
                                                <div className="ab-cards-wrapper">
                                                    <img
                                                        src="https://hotelmanager.abouthotelier.com/Images/democards.png"
                                                        width="100px"
                                                    />
                                                </div>
                                            </div>

                                            <div
                                                ref={div2Ref}
                                                className="ab-booking-form ab-mb-20"
                                            >
                                                <div className="ab-input-field-cnt ab-mb-10">
                                                    <div className=" ab-input-cnt">
                                                        <label className="ab-input-label">
                                                            {
                                                                Lang.paymentCardNumber
                                                            }
                                                            <span
                                                                className="ab-input-required-indicator"
                                                                role="presentation"
                                                                aria-hidden="true"
                                                            >
                                                                *
                                                            </span>
                                                        </label>
                                                        <Input
                                                            className="ab-input"
                                                            isRequired
                                                            isInvalid={Boolean(
                                                                errors?.cardno
                                                            )}
                                                            value={ccFormat(
                                                                card.cardno
                                                            )}
                                                            errorMsg={
                                                                errors?.cardno
                                                            }
                                                            isRequiredBorder={
                                                                true
                                                            }
                                                            onChange={onChange}
                                                            onKeyPress={(
                                                                event
                                                            ) => {
                                                                if (
                                                                    !/[0-9]/.test(
                                                                        event.key
                                                                    )
                                                                ) {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            id="form-Cardno"
                                                        />
                                                    </div>
                                                    <div className="ab-input-field-cnt">
                                                        <div className=" ab-input-cnt">
                                                            <label className="ab-input-label">
                                                                {
                                                                    Lang.expiration
                                                                }{' '}
                                                                (MM/YY)
                                                                <span
                                                                    className="ab-input-required-indicator"
                                                                    role="presentation"
                                                                    aria-hidden="true"
                                                                >
                                                                    *
                                                                </span>
                                                            </label>
                                                            <Input
                                                                onChange={
                                                                    onChangeExp
                                                                }
                                                                className="ab-input"
                                                                isRequired
                                                                isInvalid={Boolean(
                                                                    errors?.expirydt
                                                                )}
                                                                errorMsg={
                                                                    errors?.expirydt
                                                                }
                                                                isRequiredBorder={
                                                                    true
                                                                }
                                                                maxlength="5"
                                                                value={expriyFormat(
                                                                    card.expirydt
                                                                )}
                                                                id="form-Expire"
                                                            />
                                                        </div>
                                                        <div className=" ab-input-cnt">
                                                            <label className="ab-input-label">
                                                                CVV
                                                                <span
                                                                    className="ab-input-required-indicator"
                                                                    role="presentation"
                                                                    aria-hidden="true"
                                                                >
                                                                    *
                                                                </span>
                                                            </label>
                                                            <Input
                                                                onChange={
                                                                    onChangeCVV
                                                                }
                                                                maxlength="3"
                                                                pattern="[0-9][0-9][0-9]"
                                                                onKeyPress={(
                                                                    event
                                                                ) => {
                                                                    if (
                                                                        !/[0-9]/.test(
                                                                            event.key
                                                                        )
                                                                    ) {
                                                                        event.preventDefault();
                                                                    }
                                                                }}
                                                                type="password"
                                                                className="ab-input"
                                                                isRequired
                                                                isInvalid={Boolean(
                                                                    errors?.cvv
                                                                )}
                                                                errorMsg={
                                                                    errors?.cvv
                                                                }
                                                                isRequiredBorder={
                                                                    true
                                                                }
                                                                id="form-Cvv"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="ab-input-field-cnt ab-mb-10">
                                                    <div className=" ab-input-cnt">
                                                        <label className="ab-input-label">
                                                            {Lang.nameOnCard}
                                                            <span
                                                                className="ab-input-required-indicator"
                                                                role="presentation"
                                                                aria-hidden="true"
                                                            >
                                                                *
                                                            </span>
                                                        </label>
                                                        <Input
                                                            onChange={
                                                                onChangeCardName
                                                            }
                                                            className="ab-input"
                                                            isRequired
                                                            isInvalid={Boolean(
                                                                errors?.cardname
                                                            )}
                                                            errorMsg={
                                                                errors?.cardname
                                                            }
                                                            isRequiredBorder={
                                                                true
                                                            }
                                                            id="form-CardName"
                                                        />
                                                    </div>
                                                    <div className="ab-input-cnt"></div>
                                                </div>
                                            </div>

                                            <div className="ab-whitebox-secondary-title ab-flex-between">
                                                <div className="ab-body-sidebar-section ab-whitebox ab-info-box ab-mb-20 ab-p-10 ab-box-shadow only-mobile">
                                                    <div className="ab-bordered-title">
                                                        {
                                                            Lang.howMuchWillItCostToCancel
                                                        }
                                                        ?
                                                    </div>
                                                    <div className="ab-price-line-p">
                                                        <span
                                                            className="price-line-text"
                                                            dangerouslySetInnerHTML={{
                                                                __html: rate?.cancelationPolicy.replace(
                                                                    /\./g,
                                                                    '.<br/>'
                                                                ),
                                                            }}
                                                        ></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ display: 'none' }}>
                                                <div className="ab-whitebox-secondary-title ab-flex-center">
                                                    <div className="info-line-icon">
                                                        <FaRegCalendarAlt color="#343434" />
                                                    </div>
                                                    <div
                                                        className="info-line-text"
                                                        style={{
                                                            fontWeight: '100',
                                                        }}
                                                    >
                                                        {
                                                            tmpUserBookingData.checkin
                                                        }{' '}
                                                        -{' '}
                                                        {
                                                            tmpUserBookingData.checkout
                                                        }
                                                    </div>
                                                </div>
                                                <div className="ab-whitebox-secondary-title ab-flex-center">
                                                    <div className="info-line-icon">
                                                        <FaUserAlt color="#343434" />
                                                    </div>
                                                    <div
                                                        className="info-line-text"
                                                        style={{
                                                            fontWeight: '100',
                                                        }}
                                                    >
                                                        {Lang.Adults}:{' '}
                                                        {
                                                            tmpUserBookingData.adults
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />
                                            <div
                                                className="ab-pt-10 ab-pb-10 ab-booking-form-terms"
                                                style={{ display: 'flex' }}
                                                id="form-checkbox"
                                                ref={div3Ref}
                                            >
                                                <Checkbox
                                                    className="ab-booking-form-checkbox"
                                                    id="termsCheck"
                                                    isChecked={checked}
                                                    onChange={(event) =>
                                                        setChecked(
                                                            event.target.checked
                                                        )
                                                    }
                                                ></Checkbox>
                                                <span
                                                    style={{
                                                        paddingRight: '3px',
                                                    }}
                                                >
                                                    {
                                                        Lang?.iHaveReadAndIAcceptThe
                                                    }
                                                </span>
                                                <span
                                                    className="ab-booking-form-terms-inner"
                                                    onClick={() =>
                                                        handleInfoIconClick({
                                                            cancellationPolicyType:
                                                                rate?.cancelationPolicyType,
                                                            cancellationPolicy:
                                                                rate?.cancelationPolicy,
                                                            cancellationPenalty:
                                                                rate?.cancelationPenalty,
                                                            paymentPolicy:
                                                                rate?.paymentPolicy,
                                                        })
                                                    }
                                                >
                                                    {Lang?.termsAndConditions}
                                                </span>
                                                {Lang?.TmpTermsAndConditions && (
                                                    <>
                                                        <span
                                                            style={{
                                                                padding:
                                                                    '0 3px',
                                                            }}
                                                        >
                                                            &
                                                        </span>
                                                        <a
                                                            className="ab-booking-form-terms-inner"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            href={
                                                                Lang?.TmpTermsAndConditions
                                                            }
                                                        >
                                                            {
                                                                Lang?.privacyPolicy
                                                            }
                                                        </a>
                                                    </>
                                                )}

                                                {Boolean(errors?.checked) && (
                                                    <span className="ab-booking-form-check-required">
                                                        {Lang?.requiredField}
                                                    </span>
                                                )}
                                            </div>
                                            <hr />
                                            <div
                                                className="mail-send-info ab-pt-10 ab-pb-10"
                                                style={{ paddingLeft: '2px' }}
                                            >
                                                <FaEnvelope size={16} />
                                                <span className="ab-booking-form-email-text">
                                                    {
                                                        Lang?.wellSendConfirmationOfBookingToEmail
                                                    }{' '}
                                                    <strong>{email}</strong>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ab-booking-form-button-wrapper">
                                        <button
                                            type="submit"
                                            className="ab-full-width-big-btn"
                                            style={{
                                                backgroundColor: '#2a4090',
                                                color: colors?.primaryTextColor,
                                            }}
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <BarsLoadingIndicator />
                                            ) : (
                                                Lang?.confirmAndBook
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    ) : (
                        <FinalStepBookingForm bookingID={bookingID} />
                    )}
                </div>
            </div>
        </div>
    );
}
BookingWidgetForm.propTypes = {
    extraClass: PropTypes.string,
};

export default BookingWidgetForm;
